var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    style: {
      'font-family': _vm.font
    },
    attrs: {
      "color": "secondary"
    }
  }, [_c('script2', {
    attrs: {
      "src": "./js/live2dcubismcore.min.js"
    }
  }), _c('v-app-bar', {
    attrs: {
      "app": "",
      "clipped-left": "",
      "clipped-right": "",
      "color": "secondary",
      "height": "56",
      "elevation": "0"
    }
  }, [_c('v-btn', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.navigation = !_vm.navigation;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-menu")])], 1), !_vm.allLoaded && _vm.databaseProgress.total > 0 ? _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.databaseProgress.loaded) + " / " + _vm._s(_vm.databaseProgress.total) + " Loading...")]) : _vm._e(), _c('v-toolbar-title', {
    staticClass: "px-2 px-sm-4"
  }, [_vm._v(_vm._s(_vm.title) + " ")]), _c('v-spacer'), _c('div', {
    staticClass: "hidden-xs-only"
  }, [_c('Theme'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$root.$emit('dark');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-theme-light-dark")])], 1), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("mdi-translate")])], 1)];
      }
    }])
  }, [_c('v-list', [_c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('ja');
      }
    }
  }, [_vm._v("日本語")]), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('zh');
      }
    }
  }, [_vm._v("中文")]), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('en');
      }
    }
  }, [_vm._v("English")]), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('ko');
      }
    }
  }, [_vm._v("한국어")])], 1)], 1)], 1), _c('v-btn', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.collection = !_vm.collection;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-star")])], 1)], 1), _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "clipped": "",
      "mobile-breakpoint": "512",
      "mini-variant": _vm.$vuetify.breakpoint.smOnly || _vm.$vuetify.breakpoint.mdOnly,
      "mini-variant-width": "64"
    },
    model: {
      value: _vm.navigation,
      callback: function callback($$v) {
        _vm.navigation = $$v;
      },
      expression: "navigation"
    }
  }, [_c('v-toolbar', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "color": "secondary",
      "elevation": "0"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.navigation = !_vm.navigation;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _c('v-spacer'), _c('Theme'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$root.$emit('dark');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-theme-light-dark")])], 1), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("mdi-translate")])], 1)];
      }
    }])
  }, [_c('v-list', [_c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('ja');
      }
    }
  }, [_vm._v("日本語")]), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('zh');
      }
    }
  }, [_vm._v("中文")]), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('en');
      }
    }
  }, [_vm._v("English")]), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.setLocale('ko');
      }
    }
  }, [_vm._v("한국어")])], 1)], 1)], 1), _c('Navigation', {
    style: {
      height: "calc(100vh - 56px)"
    }
  })], 1), _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "clipped": "",
      "right": "",
      "mobile-breakpoint": "512",
      "touchless": "",
      "mini-variant": _vm.$vuetify.breakpoint.smOnly,
      "mini-variant-width": "64"
    },
    model: {
      value: _vm.collection,
      callback: function callback($$v) {
        _vm.collection = $$v;
      },
      expression: "collection"
    }
  }, [_c('v-toolbar', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "color": "secondary",
      "elevation": "0"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('Collection')))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.collection = !_vm.collection;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), !_vm.databaseStatus ? _c('div', [_c('div', {
    staticClass: "pa-8 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)]) : _c('Collection')], 1), _c('v-main', [_vm.databaseStatus == 0 ? _c('div', {
    staticClass: "pa-8 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "rotate": "-90",
      "indeterminate": !_vm.databaseProgress,
      "value": _vm.databaseProgress.loaded / _vm.databaseProgress.total * 100
    }
  }), _c('div', {
    staticClass: "pa-2 caption"
  }, [_c('span', [_vm._v("Loading Database...")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.databaseProgress,
      expression: "databaseProgress"
    }]
  }, [_vm._v(" " + _vm._s(_vm.databaseProgress.loaded) + " / " + _vm._s(_vm.databaseProgress.total))])])], 1) : _c('div', {
    staticStyle: {
      "max-width": "768px",
      "margin": "auto",
      "padding": "32px 0 80px 0"
    }
  }, [!_vm.allLoaded && !_vm.reRendering ? _c('span', [_c('router-view')], 1) : _c('span', [_c('keep-alive', [_c('router-view')], 1)], 1)])]), _c('v-fade-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.$route.params.id,
      expression: "this.$route.params.id"
    }],
    staticStyle: {
      "position": "fixed",
      "bottom": "16px"
    },
    style: {
      left: "".concat(_vm.fixedPosition(false), "px")
    },
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.setCollection
    }
  }, [_vm.getCollection(_vm.magic) ? _c('v-icon', [_vm._v("mdi-heart")]) : _c('v-icon', [_vm._v("mdi-heart-outline")])], 1)], 1), _c('v-fade-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.$route.name != 'Home',
      expression: "this.$route.name!='Home'"
    }],
    staticStyle: {
      "position": "fixed",
      "bottom": "16px"
    },
    style: {
      right: "".concat(_vm.fixedPosition(true), "px")
    },
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$vuetify.goTo(0);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-up")])], 1)], 1), _c('v-snackbar', {
    attrs: {
      "timeout": -1
    },
    model: {
      value: _vm.snackbar,
      callback: function callback($$v) {
        _vm.snackbar = $$v;
      },
      expression: "snackbar"
    }
  }, [_c('div', {
    staticClass: "d-block py-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm.databaseStatus == 2 ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "rotate": "-90",
      "indeterminate": !_vm.databaseProgress,
      "value": _vm.databaseProgress.loaded / _vm.databaseProgress.total * 100
    }
  }), _c('div', {
    staticClass: "pa-2 caption"
  }, [_c('span', [_vm._v("Loading Database...")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.databaseProgress,
      expression: "databaseProgress"
    }]
  }, [_vm._v(" " + _vm._s(_vm.databaseProgress.loaded) + " / " + _vm._s(_vm.databaseProgress.total))])])], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.databaseStatus == 3,
      expression: "databaseStatus==3"
    }],
    staticClass: "text-center mb-2"
  }, [_vm._v(_vm._s(_vm.$t('Updated.Database')))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.applicationStatus,
      expression: "applicationStatus"
    }],
    staticClass: "text-center mb-2"
  }, [_vm._v(_vm._s(_vm.$t('Updated.Application')))]), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.refresh,
      expression: "refresh"
    }],
    staticClass: "mx-0",
    attrs: {
      "text": "",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.reload();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Refresh')))]), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "text": "",
      "block": ""
    },
    on: {
      "click": function click($event) {
        _vm.snackbar = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])], 1)]), _c('Clea', {
    attrs: {
      "show": _vm.cleaVisibility
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }